import React, { useState } from "react";
import { useParams } from "react-router-dom"; // Get URL parameters
import "../styles/Contact.css"; // Make sure to style it properly

const API_BASE_URL = import.meta.env.VITE_API_URL;

const Contact = () => {
  const { source } = useParams(); // Read source from URL
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
	source: source || "General" // Default to General if no source
  });
  const [submitted, setSubmitted] = useState(false);
  
  console.log(source);

  // Custom messages based on the source
  const getMessage = () => {
    if (source === "Listing") {
      return "Let's talk to see if MILO can help improve the quality of your tenant leads.";
    } else if (source === "Tenant") {
      return "Let's talk to see if MILO is the right tool to help you find your next apartment.";
    }
    return "Please fill out the contact form below and we will reach out as soon as possible";
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch(`${API_BASE_URL}/messaging/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    });

    if (response.ok) {
      setSubmitted(true);
    }
  };

  return (
	<div className="contact-container">
      <h1>Contact Us</h1>
      <p>{getMessage()}</p> {/* Dynamic message based on the source */}

      {submitted ? (
        <p className="success-message">Thank you! We'll be in touch soon.</p>
      ) : (
        <form onSubmit={handleSubmit} className="contact-form">
          <label>Name:</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />

          <label>Email:</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />

          <label>Message:</label>
          <textarea name="message" value={formData.message} onChange={handleChange} required />

          <div className="button-container">
            <button type="submit" className="submit-button">Send Message</button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Contact;


